
        import 'QuoteFooter.14d0dd2.css-module'
        export default {"Footer":"Footer_QuoteFooter_14d0dd2","CurrentPrice":"CurrentPrice_QuoteFooter_14d0dd2","NewPrice":"NewPrice_QuoteFooter_14d0dd2","ProceedButton":"ProceedButton_QuoteFooter_14d0dd2"}
    